export default (state = {}, action) => {

    switch (action.type) {

        case 'GETTING_RSS_FEED':
            return Object.assign({},state,{
                ui: action.payload.ui
            })
        case 'GET_RSS_FEED_SUCCESS':
            return Object.assign({},state,{
                ui: action.payload.ui,
                data: action.payload.items
            })
        case 'GET_RSS_FEED_ERROR':
            return Object.assign({},state,{
                ui: action.payload.ui,
                message: action.payload.message
            })
        default:
            return state
    }
}
